export const SUPPORTED_LANGUAGES = [
  { code: 'en', name: 'English',    label: 'EN' },
  { code: 'de', name: 'Deutsch',    label: 'DE' },
  { code: 'es', name: 'Español',    label: 'ES' },
  { code: 'fr', name: 'Français',   label: 'FR' },
  { code: 'it', name: 'Italiano',   label: 'IT' },
  { code: 'nl', name: 'Nederlands', label: 'NL' },
] as const;

export type LangCode = typeof SUPPORTED_LANGUAGES[number]['code'];
export const SUPPORTED_LANG_CODES = SUPPORTED_LANGUAGES.map(l => l.code);
export const DEFAULT_LANG: LangCode = SUPPORTED_LANGUAGES[0].code;

export const LANG_STORAGE_KEY = 'lang';

export function isSupportedLang(code: string | null | undefined): code is LangCode {
  return !!code && (SUPPORTED_LANG_CODES as readonly string[]).includes(code);
}

export function getStoredLang(): LangCode {
  const saved = localStorage.getItem(LANG_STORAGE_KEY);
  return isSupportedLang(saved) ? saved : DEFAULT_LANG;
}

export function setStoredLang(code: LangCode): void {
  localStorage.setItem(LANG_STORAGE_KEY, code);
}
